import React, { useState } from 'react';
import { Box, Container, Heading, Text } from '@qga/roo-ui/components';

import BackLink from '@/components/BackLink';
import Divider from '@/components/Divider';
import Layout from '@/components/Layout';
import Link from '@/components/Link';
import Page from '@/components/Page';
import DestinationLinks from '@/v2/components/ui/SiteFooter/components/DestinationLinks';
import useActivitiesCustomer from '@/v2/hooks/featureFlags/useActivitiesCustomer/useActivitiesCustomer';
import usePageViewEvent from '@/v2/hooks/usePageViewEvent';
import DocumentTitle from '../DocumentTitle';
import LoadingOverlay from '../LoadingOverlay';
import MetaDescription from '../MetaDescription';
import ActivitiesSupport from './components/ActivitiesSupport';
import DataLayer from './components/DataLayer';
import EmailUs from './components/EmailUs';
import Sales from './components/Sales';
import Section from './components/Section';
import Support from './components/Support';

const ContactUsPage = () => {
  const [submitting, setSubmitting] = useState(false);
  const { isReady, isActivitiesCustomer } = useActivitiesCustomer();

  usePageViewEvent({ type: 'contact_us' });

  return (
    <Layout>
      <DataLayer />
      <DocumentTitle>Contact Us</DocumentTitle>
      <MetaDescription
        // eslint-disable-next-line max-len
        content="Visit our customer service page to get in touch via email, call or request a callback."
      />
      {submitting && (
        <LoadingOverlay>
          <Heading.h4 mt="6" mb="6">
            Thank you, we&lsquo;re sending your query now
          </Heading.h4>
        </LoadingOverlay>
      )}
      <Page data-testid="CONTACT_US_PAGE">
        <Container>
          <Box bg="white" py="8">
            <BackLink>Back</BackLink>
            <Box mt="2" mb="10" fontSize={['2xl', null, '3xl']}>
              Contact Us
            </Box>

            <Box mb="10">
              <Box mb="4" fontSize="xl">
                Frequently Asked Questions
              </Box>

              <Section>
                <Box>
                  Please review the <Link.Text href="/faqs">FAQs </Link.Text>{' '}
                  before getting in touch with our team.
                </Box>
              </Section>
            </Box>

            <Support />

            <Box mb="16">
              <Box mb="4" fontSize="xl">
                Qantas Tours (Sales & Support)
              </Box>
              <Divider mb="10" />
              <Section>
                <Text fontWeight="bold">Qantas Tours</Text> is managed and
                operated by <Text fontWeight="bold">TripADeal</Text>, a
                subsidiary of the Qantas Group. Need to change, cancel or
                enquire about your booking? Please visit{' '}
                <Link.Text href="https://www.tripadeal.com.au/contact-us">
                  TripADeal Contact Us page
                </Link.Text>
                . To view your bookings details, please login to the{' '}
                <Link.Text href="https://www.tripadeal.com.au/signin">
                  My Bookings
                </Link.Text>{' '}
                page. (Note: this is <Text fontWeight="bold">not</Text> your
                Qantas login)
              </Section>
            </Box>

            {isReady && isActivitiesCustomer && <ActivitiesSupport />}

            <Sales />
          </Box>
        </Container>
        <EmailUs setSubmitting={setSubmitting} />
      </Page>
      <Box mt="10">
        <DestinationLinks />
      </Box>
    </Layout>
  );
};

export default ContactUsPage;
